<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        classTabContent="pl-12 pr-12"
                        class="mt-3"
                        :data="tabData"
                        activeKey="daily_view">
                    <template slot="gofixTab:daily_view">
                            <daily></daily>
                    </template>
                    <template slot="gofixTab:weekly_view">
                            <weekly></weekly>
                    </template>
                    <template slot="gofixTab:monthly_view">
                            <monthly></monthly>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>

<script>
const daily = () => import('./daily')
const weekly = () => import('./weekly')
const monthly = () => import('./monthly')
export default {
    name: 'job-calendar-main',
    components: {
        daily,
        weekly,
        monthly
    },
    data() {
        return{
            tabData:[
                {
                    key: "daily_view",
                    title: "DAILY VIEW",
                    active: true,
                },
                {
                    key: "weekly_view",
                    title: "WEEKLY VIEW",
                    active: false,
                },
                {
                    key: "monthly_view",
                    title: "MONTHLY VIEW",
                    active: false,
                },
            ]
        }
    },
}
</script>
